import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import UiToolbar from '@material-ui/core/Toolbar';
import { Transition } from 'react-transition-group';
import { Link as ScLink } from 'react-scroll';
import Link from './Link';

import styles from './Toolbar.module.css';
import ContactInfo from './ContactInfo';

const Toolbar = ({ className, links, logo, expanded, company }) => {
  return (
    <div className={`${className} ${styles.root}`}>
      <Transition in={expanded} timeout={300}>
        {state => {
          return (
            <span className={styles[state] || ''}>
              <AppBar position="sticky" className={styles.appBar}>
                <UiToolbar color="secondary" className={styles.wrapper}>
                  {logo}
                  <div className={styles.linkWrapper}>
                    {links.map(({ name, active, onClick, el, ...rest }) => (
                      <ScLink spy smooth to={el} key={name} {...rest}>
                        <Link tag="h4" name={name} active={active} onClick={onClick} />
                      </ScLink>
                    ))}
                  </div>
                  <ContactInfo className={styles.fadeIn} company={company} />
                </UiToolbar>
              </AppBar>
            </span>
          );
        }}
      </Transition>
    </div>
  );
};

Toolbar.propTypes = {
  company: PropTypes.shape({
    addressFields: PropTypes.arrayOf(PropTypes.string),
    address: PropTypes.string,
    name: PropTypes.string,
    ceo: PropTypes.string,
    mobile: PropTypes.string,
    mail: PropTypes.string,
    phone: PropTypes.string,
    coordinates: PropTypes.shape({ lat: PropTypes.number.isRequired, lon: PropTypes.number.isRequired }),
  }).isRequired,
  offset: PropTypes.number,
  logo: PropTypes.node.isRequired,
  links: PropTypes.arrayOf(PropTypes.any),
  expanded: PropTypes.bool.isRequired,
};

Toolbar.defaultProps = {
  offset: 64 * 1.5,
};

export default Toolbar;



// WEBPACK FOOTER //
// ./src/components/Toolbar.js